export const MoreIcon = ({ onClick }: { onClick?: () => void }) =>
    <span onClick={onClick}>
         <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="24.000000" height="24.000000" fill="none">
    <defs>
        <clipPath id="clipPath_0">
            <rect width="16.000000" height="16.000000" x="4.000000" y="4.000000" fill="rgb(255,255,255)" />
        </clipPath>
    </defs>
    <rect id="Wrapper" width="24.000000" height="24.000000" x="0.000000" y="0.000000" />
    <g id="24 / Navigation / Menu Kebab">
        <rect id="24 / Navigation / Menu Kebab" width="16.000000" height="16.000000" x="4.000000" y="4.000000" />
        <path id="Union" d="M13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z" fill="rgb(88,93,105)" fillRule="evenodd" />
    </g>
</svg>
    </span>
